import { useState } from 'react';

interface ProductGalleryProps {
  images: string[];
  name: string;
}

export default function ProductGallery({ images, name }: ProductGalleryProps) {
  const [activeIndex, setActiveIndex] = useState(0);

  const prev = () => setActiveIndex((i) => (i === 0 ? images.length - 1 : i - 1));
  const next = () => setActiveIndex((i) => (i === images.length - 1 ? 0 : i + 1));

  return (
    <div className="flex flex-col gap-4">
      {/* Main Image */}
      <div className="relative rounded-2xl overflow-hidden bg-[#faf8f5] aspect-square">
        <img
          key={activeIndex}
          src={images[activeIndex]}
          alt={`${name} - 图片${activeIndex + 1}`}
          className="w-full h-full object-cover object-top transition-opacity duration-300"
        />

        {/* Nav Arrows */}
        <button
          onClick={prev}
          className="absolute left-3 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center rounded-full bg-white/80 hover:bg-white transition-colors cursor-pointer"
        >
          <i className="ri-arrow-left-s-line text-[#1a1a1a] text-lg"></i>
        </button>
        <button
          onClick={next}
          className="absolute right-3 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center rounded-full bg-white/80 hover:bg-white transition-colors cursor-pointer"
        >
          <i className="ri-arrow-right-s-line text-[#1a1a1a] text-lg"></i>
        </button>

        {/* Dot Indicator */}
        <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5">
          {images.map((_, i) => (
            <button
              key={i}
              onClick={() => setActiveIndex(i)}
              className={`rounded-full transition-all cursor-pointer ${
                i === activeIndex ? 'w-5 h-1.5 bg-[#C8714A]' : 'w-1.5 h-1.5 bg-white/60'
              }`}
            />
          ))}
        </div>
      </div>

      {/* Thumbnails */}
      <div className="grid grid-cols-4 gap-2">
        {images.map((img, i) => (
          <button
            key={i}
            onClick={() => setActiveIndex(i)}
            className={`rounded-xl overflow-hidden aspect-square cursor-pointer border-2 transition-all ${
              i === activeIndex ? 'border-[#C8714A]' : 'border-transparent hover:border-[#C8714A]/40'
            }`}
          >
            <img
              src={img}
              alt={`缩略图${i + 1}`}
              className="w-full h-full object-cover object-top"
            />
          </button>
        ))}
      </div>
    </div>
  );
}
